import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { fetchArticles, catLabel, catAccent } from "@/lib/api";
import { ArticleCard } from "@/components/ArticleCard";

export default function CategoryPage() {
  const { categoryId } = useParams();
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetchArticles({ category: categoryId })
      .then(setArticles)
      .finally(() => setLoading(false));
  }, [categoryId]);

  return (
    <main className="pt-32 pb-16 max-w-7xl mx-auto px-4 sm:px-6" data-testid="category-page">
      <motion.div
        key={categoryId}
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="mb-12 border-b border-white/10 pb-8"
      >
        <span className="font-mono-meta text-xs uppercase tracking-[0.3em]" style={{ color: catAccent(categoryId) }}>
          श्रेणी
        </span>
        <h1 className="font-display text-4xl sm:text-5xl text-white mt-3">{catLabel(categoryId)}</h1>
        <p className="font-mono-meta text-xs text-slate-500 mt-3">{articles.length} लेख उपलब्ध</p>
      </motion.div>
      {loading ? (
        <div className="py-20 text-center font-mono-meta text-xs text-slate-500 uppercase tracking-widest">लोड हो रहा है...</div>
      ) : articles.length === 0 ? (
        <div className="py-20 text-center text-slate-400">इस श्रेणी में अभी कोई लेख नहीं है।</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.map((a, i) => (
            <ArticleCard key={a.id} article={a} index={i} />
          ))}
        </div>
      )}
    </main>
  );
}
